<template>
  <v-row class="assign-devices custom-scroll-bar">
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      top
      :color="snackbarColor"
      rounded
      centered
    >
      {{ snackbarText }}
    </v-snackbar>
    <v-col cols="12" sm="2" class="profile-pic-col">
      <div class="img-div">
        <v-img class="profile-pic" id="profile-pic" height="100%" width="100%" :src="profilePicSrc"/>
      </div>
    </v-col>
    <v-col cols="12" sm="10">
      <v-row no-gutters>
        <v-col cols="12">
          <p class="title-text">{{$t('AssignDevices.title', [userData.name])}}</p>
        </v-col>
      </v-row>
      <v-row style="place-content: end" no-gutters>
        <v-flex class="px-2">
          <v-row class="device-elements flex-nowrap" justify="end">
            <v-switch
              v-model="selectAll"
              inset
              color="#00D166"
            />
            <p class="mb-0 text-start break-normal">{{$t('AssignDevices.selectAll')}}</p>
          </v-row>
        </v-flex>
      </v-row>
      <v-progress-circular v-if="this.loadingDevices" indeterminate :size="50" color="grey"></v-progress-circular>
      <v-row v-if="!this.loadingDevices" no-gutters>
        <v-flex v-for="(device) in assignedDevices" :key="device.name" xs6 sm4 md3 xl2 class="px-2">
          <v-row class="device-elements flex-nowrap">
            <v-switch
              v-model="device.isAssigned"
              inset
              color="#00D166"
            />
            <p class="mb-0 text-start">{{device.campaign.entityName}}</p>
          </v-row>
        </v-flex>
      </v-row>
      <!-- Commented until device creation is implemented without losing user data
      <v-row no-gutters class="pt-5">
        <v-col cols="12" class="text-left">
          <a @click="addDevice" class="add-equipment-btn">+ {{$t('AssignDevices.addDevice')}}</a>
        </v-col>
      </v-row>
      -->
    </v-col>
    <v-row class="mt-6" justify="center">
      <v-col cols="12" sm="3">
        <v-btn
          block
          color="#0098E1"
          large
          class="text-none text-h6 font-weight-light"
          dark
          @click="isAssignedDevices.length ? nextStep() : saveUserData()"
          :loading="this.loading"
        >{{isAssignedDevices.length ? $t('AssignDevices.next') : $t('AssignDevices.save')}}</v-btn>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import { insertNewUser } from '../../../lib/crudOperations/write'

export default {
  props: {
    userData: {
      type: Object,
      required: true
    },
    userRegisterStep: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      profilePicSrc: null,
      assignedDevices: [],
      loading: false,
      loadingDevices: true,
      selectAll: false,
      snackbar: false,
      snackbarTimeout: 3000,
      snackbarText: '',
      snackbarColor: ''
    }
  },
  created () {
    this.setUserImg()
    this.getDevices()
  },
  methods: {
    setUserImg () {
      if (this.userData.photoUrl) {
        this.profilePicSrc = this.userData.profilePic
      } else {
        switch (this.userData.role) {
          case 'admin':
          case 'owner':
            this.profilePicSrc = require('../../../assets/owner.png')
            break
          case 'manager':
            this.profilePicSrc = require('../../../assets/manager.png')
            break
          case 'fieldman':
            this.profilePicSrc = require('../../../assets/fieldman.png')
            break
          case 'farmhand':
            this.profilePicSrc = require('../../../assets/farmhand.png')
            break
        }
      }
    },
    addDevice () {
      this.$router.push({name: 'AddDevice'})
    },
    async getDevices () {
      try {
        this.loadingDevices = true
        // Always use devices from the active campaign (stored in the main store)
        this.assignedDevices = this.$store.getters.devices

        // Set all the devices as unassigned by default.
        this.assignedDevices = this.assignedDevices.map(device => { return {...device, isAssigned: false} })
      } catch (error) {
        this.snackbar = true
        this.snackbarText = this.$t('AssignDevices.loadingDevicesError')
        this.snackbarColor = '#F93A2F'
      } finally {
        this.loadingDevices = false
      }
    },
    async saveUserData () {
      this.loading = true
      try {
        await insertNewUser(this.userData, this.assignedDevices)
        this.$router.push({name: 'OrganizationHome'})
        this.$root.snack.show({text: this.$t('UI.registerSuccess')})
      } catch (error) {
        this.$root.snack.show({text: this.$t('UI.serverError'), error: true})
      } finally {
        this.loading = false
      }
    },
    async nextStep () {
      this.$emit('update:userData', {
        ...this.userData,
        assignedDevices: this.isAssignedDevices,
        devices: this.isAssignedDevices.map(device => device.id)
      })
      this.$emit('update:userRegisterStep', this.userRegisterStep + 1)
    }
  },
  watch: {
    selectAll (val) {
      this.assignedDevices = this.assignedDevices.map(device => { return {...device, isAssigned: val} })
    }
  },
  computed: {
    isAssignedDevices () {
      return this.assignedDevices.filter(device => device.isAssigned)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssignDevices.vue?3ff4f805